import { useState } from 'react';
import { showDialogConfermaModifica } from '../../../../../utils/dialog/showDialogFunction';
import DonutChartScore from '../../../../../utils/DonutChartScore';
import Swal from 'sweetalert2';
import { cleanContent } from '../../../../../utils/cleanContent';
import { ElementRead, ElementUpdate, IndicatoreItem, Metric, SourceRead } from '../../../../../api/apiTypes';
import { updateElement, validaElement } from '../../../../../api/functionApi';
import { ConfirmValidationDialog } from '../../../../../utils/dialog/ConfirmValidationDialog';
import { useAxiosInterceptor } from '../../../../../api/wrappers';
import ElementGenerationsPanel from '../../../ElementGenerationsPanel';
import EventList from '../../../../../utils/EventList';
import SourcesAccordion from '../../../../../components/report/SourcesAccordion';
import { showIndicatoreModal } from './IndicatoreModal';

type ContainerListaDriverPageProps = {
  intermediario: ElementRead;
  title: string;
  driverRoute: string;
  id: string;
  driverId: string;
  intermediarioId: string
  sources: SourceRead[]
    events: any[]

};

const ContainerBestExecutionDettaglio = ({
  intermediario,
  title,
  driverRoute,
  id,
  driverId,
  intermediarioId,
  sources,
  events
}: ContainerListaDriverPageProps) => {
  useAxiosInterceptor(); // <--- monta l'interceptor
  const [localIntermediario, setLocalIntermediario] = useState<ElementRead>(intermediario);
  const isIntermediarioValidato = localIntermediario.validation === 'validated';
  const formattedTitle = title
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  const [isEditing, setIsEditing] = useState(false);
  const [showDialogConfermaValidazione, setShowDialogConfermaValidazione] = useState(false);


  const [values, setValues] = useState({
    beStatica: localIntermediario.value?.result_values?.includes('static') || false,
    beStaticaDinamica: localIntermediario.value?.result_values?.includes('mixed') || false,
    beDinamica: localIntermediario.value?.result_values?.includes('dynamic') || false,
    beDinamicaIntegrazione: localIntermediario.value?.result_values?.includes('advanced-features') || false,
  });

  const resetValues = () => {
    setValues({
      beStatica: localIntermediario.value?.result_values?.includes('static') || false,
      beStaticaDinamica: localIntermediario.value?.result_values?.includes('mixed') || false,
      beDinamica: localIntermediario.value?.result_values?.includes('dynamic') || false,
      beDinamicaIntegrazione: localIntermediario.value?.result_values?.includes('advanced-features') || false,
    });
  };

  const handleModifica = () => {
    showDialogConfermaModifica(() => {
      setIsEditing(true);
    });
  };

  const handleAnnulla = () => {
    resetValues();
    setIsEditing(false);
  };

const handleSalva = async () => {
  const nuovoMercato: string[] = [];
  if (values.beStatica) nuovoMercato.push('static');
  if (values.beStaticaDinamica) nuovoMercato.push('mixed');
  if (values.beDinamica) nuovoMercato.push('dynamic');
  if (values.beDinamicaIntegrazione) nuovoMercato.push('advanced-features');

  if (nuovoMercato.length === 0) {
    Swal.fire({
      icon: 'error',
      title: 'Modifica non possibile',
      text: 'Almeno un campo deve essere selezionato per poter salvare.',
      confirmButtonColor: '#374151',
    });
    return;
  }

  try {
const payload: ElementUpdate = { 
  value: {
    result_values: nuovoMercato,
// summary_selected_information: localIntermediario.value?.summary_selected_information || [],
// reasoning: localIntermediario.value?.reasoning || [],
// list_relevant_sentences: localIntermediario.value?.list_relevant_sentences || [],
// metrics: localIntermediario.value?.metrics || [],
  },
};

//console.log(payload , "payload");


    const updatedElement = await updateElement(id, driverId, intermediarioId, payload);
    setLocalIntermediario(updatedElement);
    setIsEditing(false);
    

    Swal.fire({
      icon: 'success',
      title: 'Modifica salvata!',
      text: 'Le modifiche sono state salvate correttamente.',
      confirmButtonColor: '#374151',
    });
  } catch (error) {
    console.error('Errore durante il salvataggio:', error);
    Swal.fire({
      icon: 'error',
      title: 'Errore nel salvataggio',
      text: 'Si è verificato un errore durante il salvataggio delle modifiche.',
      confirmButtonColor: '#374151',
    });
  }
};



  const onClickValida = () => {
    setShowDialogConfermaValidazione(true);
  };

  const handleValidazione = async () => {
    setShowDialogConfermaValidazione(false); // chiudo il dialog
  
    const nuovoMercato: string[] = [];
    if (values.beStatica) nuovoMercato.push('static');
    if (values.beStaticaDinamica) nuovoMercato.push('mixed');
    if (values.beDinamica) nuovoMercato.push('dynamic');
    if (values.beDinamicaIntegrazione) nuovoMercato.push('advanced-features');
  
    if (nuovoMercato.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Validazione non possibile',
        text: 'Almeno un campo deve essere selezionato per poter validare.',
        confirmButtonColor: '#374151',
      });
      return;
    }
   // Mostra Swal di caricamento
  Swal.fire({
    title: 'Validazione in corso...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });
    try {
      const updatedElement = await validaElement(id, driverId, intermediarioId);
      setLocalIntermediario(updatedElement);
      setIsEditing(false);
  
      Swal.fire({
        icon: 'success',
        title: 'Validazione completata!',
        text: 'La strategia è stata validata correttamente.',
        confirmButtonColor: '#374151',
      });
    } catch (error) {
      console.error('Errore durante la validazione:', error);
      Swal.fire({
        icon: 'error',
        title: 'Errore nella validazione',
        text: 'Si è verificato un errore durante la validazione.',
        confirmButtonColor: '#374151',
      });
    }
  };
  

  const handleCheckboxChange = (key: keyof typeof values) => {
    setValues(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

const handleOpenIndicatoreModal = (metric: Metric) => {
  showIndicatoreModal(metric);
};

  return (
    <div>
      {/* Input Best Execution Dettaglio */}
      <div className="card-bg p-8 rounded-lg shadow-md mt-4 ">
        <h1 className="text-4xl font-bold text-gray-dark mb-8">{formattedTitle}</h1>
        <h1 className="text-3xl font-bold text-gray-dark mb-8">{intermediario.name}</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 mb-8">
          <div>
            <label htmlFor="beStatica" className="block text-sm font-medium text-gray-medium mb-1">
              BE statica
            </label>
            <input
              type="text"
              id="beStatica"
              value={values.beStatica ? 'V' : ''}
              readOnly={!isEditing}
              onClick={() => isEditing && handleCheckboxChange('beStatica')}
              className={`mt-1 block w-full rounded-md border border-textPrimary shadow-sm focus:border-textPrimary focus:ring focus:ring-textPrimary/30 p-2 ${isEditing ? 'bg-white cursor-pointer' : 'bg-gray-100'}`}
            />
          </div>
          <div>
            <label htmlFor="beStaticaDinamica" className="block text-sm font-medium text-gray-medium mb-1">
              BE statica + dinamica
            </label>
            <input
              type="text"
              id="beStaticaDinamica"
              value={values.beStaticaDinamica ? 'V' : ''}
              readOnly={!isEditing}
              onClick={() => isEditing && handleCheckboxChange('beStaticaDinamica')}
              className={`mt-1 block w-full rounded-md border border-textPrimary shadow-sm focus:border-textPrimary focus:ring focus:ring-textPrimary/30 p-2 ${isEditing ? 'bg-white cursor-pointer' : 'bg-gray-100'}`}
            />
          </div>
          <div>
            <label htmlFor="beDinamica" className="block text-sm font-medium text-gray-medium mb-1">
              BE dinamica
            </label>
            <input
              type="text"
              id="beDinamica"
              value={values.beDinamica ? 'V' : ''}
              readOnly={!isEditing}
              onClick={() => isEditing && handleCheckboxChange('beDinamica')}
              className={`mt-1 block w-full rounded-md border border-textPrimary shadow-sm focus:border-textPrimary focus:ring focus:ring-textPrimary/30 p-2 ${isEditing ? 'bg-white cursor-pointer' : 'bg-gray-100'}`}
            />
          </div>
          <div>
            <label htmlFor="beDinamicaIntegrazione" className="block text-sm font-medium text-gray-medium mb-1">
              Integrazioni Tecniche
            </label>
            <input
              type="text"
              id="beDinamicaIntegrazione"
              value={values.beDinamicaIntegrazione ? 'V' : ''}
              readOnly={!isEditing}
              onClick={() => isEditing && handleCheckboxChange('beDinamicaIntegrazione')}
              className={`mt-1 block w-full rounded-md border border-textPrimary shadow-sm focus:border-textPrimary focus:ring focus:ring-textPrimary/30 p-2 ${isEditing ? 'bg-white cursor-pointer' : 'bg-gray-100'}`}
            />
          </div>
        </div>
{!['approved', 'drafted', 'completed'].includes(intermediario.report_status ?? '') && (

        <div className="flex justify-end space-x-4">
          {!isEditing ? (
           (
              <>
                <button
                  onClick={handleModifica}
                  className="px-4 py-2 bg-buttonPrimaryBg text-buttonPrimaryText hover:bg-buttonPrimaryHover rounded"
                >
                  Modifica
                </button>
                <button
                  onClick={onClickValida}
                    disabled={isIntermediarioValidato}
                   className={`px-4 py-2 rounded 
            ${isIntermediarioValidato 
              ? 'bg-gray-200 text-gray-400 cursor-not-allowed' 
              : 'bg-textPrimary text-white hover:bg-textSecondary'}`
          }
                >
                  Valida
                </button>
              </>
            )
          ) : (
            <>
              <button
                onClick={handleAnnulla}
                className="px-4 py-2 bg-gray-200 text-gray-800 hover:bg-gray-300 rounded"
              >
                Annulla
              </button>
              <button
                onClick={handleSalva}
                className="px-4 py-2 bg-textPrimary text-white hover:bg-textSecondary rounded"
              >
                Salva
              </button>
            </>
          )}

          {/* Dialog di conferma validazione */}
          {showDialogConfermaValidazione && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
              <div className="bg-white p-6 rounded shadow-lg max-w-sm w-full">
                <ConfirmValidationDialog
                  onConferma={handleValidazione}
                  onAnnulla={() => setShowDialogConfermaValidazione(false)}
                />
              </div>
            </div>
          )}
        </div>
)}
      </div>


{/* Sezione Leggenda */}
        <div className="mt-6 bg-gray-50 border border-gray-200 rounded-lg p-4 text-sm text-gray-700 leading-relaxed">
          <h3 className="font-semibold text-textPrimary mb-2">Legenda</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong>Best Execution dinamica:</strong> ricerca il miglior mercato in considerazione di alcuni fattori:
              prezzo; costi; rapidità e probabilità di esecuzione e di regolamento; dimensioni; natura dell’ordine;
              qualsiasi altra considerazione pertinente ai fini della sua esecuzione.
            </li>
            <li>
              <strong>Best Execution statica:</strong> prevede la possibilità di esecuzione su un’unica sede,
              per una data categoria di strumenti finanziari.
            </li>
            <li>
              <strong>Best Execution con integrazioni tecniche:</strong> quali ad esempio lo <em>sweeping</em> 
              (spostamento dell’ordine verso il mercato strategico che dovesse presentare condizioni di prezzo e quantità
              in grado di consentire, con elevata probabilità, l’esecuzione totale o parziale dell’ordine stesso) o lo 
              <em> splitting</em> (frazionamento dell’ordine, permettendone così l’esecuzione parziale su mercati differenti).
            </li>
          </ul>
        </div>
        
      {/* Note Dettaglio */}
      <div className="card-bg pt-8 bg-background ">
        <div className="bg-surface p-6 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold text-textPrimary font-heading mb-3">Riassunto informazione estratte</h2>
          <ul className="list-none list-inside text-textSecondary leading-relaxed mb-6 font-paragraph">
            {intermediario.value?.summary_selected_information && intermediario.value.summary_selected_information.map((frase: string, index: number) => (
              <li className="mb-4" key={index}>{cleanContent(frase)}</li>
            ))}

          </ul>
          <h2 className="text-xl font-semibold text-textPrimary font-heading mb-3">Frasi rilevanti </h2>
          <ul className="list-none list-inside text-textSecondary leading-relaxed mb-6 font-paragraph">
            {intermediario.value?.list_relevant_sentences && intermediario.value.list_relevant_sentences.map((frase: string, index: number) => (
              <li className="mb-4" key={index}>{cleanContent(frase)}</li>
            ))}
          </ul>
          <h2 className="text-xl font-semibold text-textPrimary font-heading mb-3">Analisi</h2>
          <ul className="list-none list-inside text-textSecondary leading-relaxed mb-2 font-paragraph">
            {intermediario.value?.reasoning && intermediario.value.reasoning.map((frase: string, index: number) => (
              <li className="mb-4" key={index}>{cleanContent(frase)}</li>
            ))}
          </ul>
        </div>
      </div>

      {/* Accordion indicatori */}
      <div className="card-bg p-8 rounded-lg shadow-md ">
        <h2 className="text-xl font-semibold text-textPrimary mb-6 font-heading">Indicatori</h2>
        {intermediario.value?.metrics && intermediario.value.metrics.length > 0 ? (
          <div>
            {intermediario.value.metrics.map((indicatoreItem: IndicatoreItem, index: number) => (
              <div key={indicatoreItem.title + index} className="mb-8">
                <h3 className="text-lg font-semibold text-textPrimary mb-4">{indicatoreItem.title}</h3>
                <div className="flex flex-wrap gap-6">
{indicatoreItem.metrics.map((metric, idx) => (
  <div
    key={metric.title + idx}
    onClick={() => handleOpenIndicatoreModal(metric)}
    className="flex items-center gap-4 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition"
  >
    <DonutChartScore score={metric.value} />
    <span className="text-textPrimary font-medium text-sm">{metric.title}</span>
  </div>
))}

</div>

              </div>
            ))}
          </div>
        ) : (
          <p className="text-textSecondary font-paragraph">Nessun indicatore disponibile.</p>
        )}
      </div>


      <SourcesAccordion sources={sources} reportId={id} componentId={driverId} elementId={intermediarioId} />
            {/* Sezione Attività */}
<EventList events={events} />
      <ElementGenerationsPanel reportId={id} componentId={driverId} elementId={intermediarioId} />
    </div>
  );
};

export default ContainerBestExecutionDettaglio;